import GeolocationService from '@/services/GeolocationService'

export default {
  actions: {
    async fetchGeolocation (ctx) {
      const geolocation = await GeolocationService.methods.getLocationInfo()
      ctx.commit('updateGeolocation', geolocation)
    }
  },
  mutations: {
    updateGeolocation (state, geolocation) {
      state.geolocation = geolocation.data
    }
  },
  getters: {
    getGeolocation (state) {
      return state.geolocation
    }
  },
  state: {
    geolocation: null
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/geolocation.js